import * as React from 'react';

export default () => (
  <React.Fragment>
    <p>
      I'm a self-taught systems engineer who learned to code writing RuneScape bots in 8th grade. Growing up in a town of 161 people meant my high school's idea of technology education was a semester of keyboarding.
    </p>
    <p>
      In high school, I inherited a gaming community with 40 members across multiple countries. I learned management by actually doing it: structuring teams, handling conflicts, building democratic voting systems in PHP to keep things running. Most of what I know about leading engineers came from leading gamers who didn't have to show up.
    </p>
    <p>
      Software engineering is a people business. The code is the easy part.
   </p>
  </React.Fragment>
);
